export default __webpack_public_path__ + "static/banner-70833e4b214e7771bbcdfda095d84e30.png";